import { useState, useCallback, useEffect } from 'react';
import cn from 'classnames';
import { Button } from 'components/Button';
import { Tooltip } from 'components/Tooltip';
import SkipIcon from 'static/images/arrow-right-red-2.svg';
import ViewIcon from 'static/images/eye.svg';
import RequestIcon from 'static/images/user-plus.svg';
import LikeIcon from 'static/images/arrow-left-green-2.svg';
import ChatIcon from 'static/images/chatBlue.svg'
import i18n from 'services/i18n';

import s from './SwipeCardActionButton.module.scss';

const buttonTypes = {
  skip: { icon: SkipIcon, className: s.skip },
  view: { icon: ViewIcon, className: s.view },
  request: { icon: RequestIcon, className: s.request },
  like: { icon: LikeIcon, className: s.like },
  chat: { icon: ChatIcon, className: s.chat },
};

const SwipeCardActionButton = ({ onClick, className, type, disabled = false, tooltip = '' }) => {
  const [animate, setAnimate] = useState(false);
  const { icon, className: typeClassName } = buttonTypes[type];

  const handleClick = useCallback((event) => {
    event.stopPropagation();
    if (disabled) return;
    setAnimate(true);
    onClick();
  }, [onClick, disabled]);

  useEffect(() => {
    if (animate) {
      const timer = setTimeout(() => setAnimate(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [animate]);

  const button = (
    <Button
      variant="contained"
      onClick={handleClick}
      isDisabled={disabled}
      className={cn(
        s.container,
        typeClassName,
        className,
        animate && s.animate,
        animate && s[`animate${type.charAt(0).toUpperCase() + type.slice(1)}`]
      )}
      aria-label={i18n.t(`swipes.${type}`)}
    >
      <div className={s.content}>
        <img src={icon} alt="" aria-hidden="true" />
        <span className={s.label}>{i18n.t(`swipes.${type}`)}</span>
      </div>
    </Button>
  );

  const stopPropagation = disabled ? (e) => e.stopPropagation() : undefined;

  if (tooltip && disabled) {
    return (
      <Tooltip title={tooltip}>
        <div onClick={stopPropagation}>
          {button}
        </div>
      </Tooltip>
    );
  }

  return disabled
    ? <div onClick={stopPropagation}>{button}</div>
    : button;
};

export { SwipeCardActionButton };